export const stages = [
  "Фактическая выгрузка",
  "Снимок рейса",
  "Сверка тарифов",
  "Тип реестра",
  "Проверка условий",
  "Допуск в реестр",
  "Формирование реестра",
  "Разбиение по лимитам",
  "Номер и статус реестра",
];
export const types = {
  regular: "Перевозка",
  return: "Возврат",
  own_fleet: "Собственный транспорт",
  downtime: "Простой",
  disruption: "Срыв",
  premium: "Премия",
};
const labels = {
  pending: "Ожидает обработки",
  recorded: "Зафиксировано",
  completed: "Завершено",
  matched: "Тарифы совпадают",
  eligible: "Условия выполнены",
  blocked: "Заблокировано",
  admitted: "Допущено",
  already_submitted: "Уже включено в реестр",
  passed: "Пройдено",
  failed: "Ошибка",
  dead: "Попытки исчерпаны",
  success: "Успешно",
  submitted: "Отправлено",
  accepted: "Принято",
  rejected: "Отклонено",
  registryCreated: "Реестр создан",
  tms_error: "Расхождение с системой заказчика",
  tm_error: "Расхождение с ТрансМенеджером",
  matrix_error: "Нет тарифа в матрице",
  erp_error: "Расхождение с учётной системой",
  processing: "Обрабатывается",
  changed: "Данные изменены",
  queued: "Ожидает отправки",
  partial: "Часть начислений требует проверки",
  formed: "Сформирован",
  assigned: "Лимиты соблюдены",
};
export const statusText = (value) => labels[value] || "Состояние уточняется";
export const managerOnly = (name) =>
  String(name || "")
    .trim()
    .toLowerCase() === "руководитель";
export function mergeHistory(current, incoming) {
  return [
    ...new Map(
      [...current, ...incoming].map((event) => [event.event_id, event])
    ).values(),
  ].sort((a, b) => a.position - b.position);
}
export function processSteps(events) {
  return stages.map((title, index) => {
    const relevant = events.filter(
      (event) => event.stage === index + 1 && !event.payload?.notification_kind
    );
    const states = new Map();
    for (const event of [...relevant].sort((a, b) => a.position - b.position)) {
      states.set(event.payload?.registry_type || "", event);
    }
    const complete =
      states.size > 0 &&
      [...states.values()].every((event) => tone(event.status) === "ready");
    return {
      key: String(index + 1),
      title,
      state: complete ? "done" : relevant.length ? "current" : "future",
      hint: title,
    };
  });
}
export function tone(status) {
  if (
    [
      "blocked",
      "failed",
      "dead",
      "rejected",
      "tms_error",
      "tm_error",
      "matrix_error",
      "erp_error",
    ].includes(status)
  )
    return "problem";
  if (
    ["pending", "processing", "changed", "queued", "partial"].includes(status)
  )
    return "waiting";
  return [
    "recorded",
    "completed",
    "matched",
    "eligible",
    "admitted",
    "already_submitted",
    "passed",
    "success",
    "submitted",
    "accepted",
    "registryCreated",
    "formed",
    "assigned",
  ].includes(status)
    ? "ready"
    : "waiting";
}
export function reasons(event) {
  const payload = event?.payload || {};
  const result = (payload.reasons || [])
    .map((row) => row.message)
    .filter(Boolean);
  const matrixIssues = {
    order_date_missing: "Не установлена дата заявки для выбора версии тарифов",
    matrix_version_missing:
      "Нет тарифной матрицы, действовавшей на дату заявки",
    overlapping_matrix_versions:
      "Периоды действия тарифных матриц пересекаются",
    matrix_route_missing: "Маршрут отсутствует в выбранной версии матрицы",
    ambiguous_matrix_route: "В версии матрицы несколько строк одного маршрута",
    customer_missing: "Не определён заказчик для сверки тарифа",
  };
  if (payload.differences?.matrix_issue)
    result.push(
      matrixIssues[payload.differences.matrix_issue] ||
        "Нужна проверка тарифной матрицы"
    );
  for (const decision of payload.decisions || []) {
    if (decision.status === "not_applicable") continue;
    for (const condition of decision.conditions || []) {
      if (!condition.passed)
        result.push(
          `${types[decision.registry_type] || "Начисление"}: ${
            condition.message
          }`
        );
    }
  }
  if (payload.error)
    result.push(
      "Не удалось завершить обработку. Система сохранит результат следующей попытки."
    );
  return [...new Set(result)];
}
export const eventLabels = {
  "registry_type.conditions_checked": "Проверены индивидуальные условия",
  "reconciliation.notification_queued": "Уведомление поставлено в очередь",
  "reconciliation.notification_delivery": "Доставка уведомления о сверке",
  "actual_unloading.recorded_in_tms": "Выгрузка зафиксирована",
  "actual_unloading.inbox_received": "Событие получено",
  "actual_unloading.snapshot_created": "Снимок сохранён",
  "actual_unloading.inbox_failed": "Ошибка сохранения снимка",
  "tariff_reconciliation.completed": "Сверка завершена",
  "registry_type.determined": "Типы определены",
  "registry_conditions.checked": "Условия проверены",
  "registry_admission.decided": "Решение о допуске",
  "registry.formed": "Реестр сформирован",
  "registry.part_assigned": "Назначена часть реестра",
  "registry.tms_response_received": "Получены номер и статус реестра",
  "registry.tms_submission_failed": "Ошибка отправки реестра",
  "registry.tms_submission_started": "Отправка реестра",
  "registry_type.evidence_changed": "Подтверждения изменены",
  "registry_type.own_fleet_changed": "Состав собственного парка изменён",
};

export function currentStates(events = []) {
  const states = new Map();
  for (const event of [...events].sort((a, b) => a.position - b.position)) {
    if (event.payload?.notification_kind) continue;
    states.set(`${event.stage}:${event.payload?.registry_type || ""}`, event);
  }
  const values = [...states.values()];
  const decisions =
    values.find((event) => event.stage === 4)?.payload?.decisions || [];
  const inactive = new Set(
    decisions
      .filter((row) => row.status === "not_applicable")
      .map((row) => row.registry_type)
  );
  return values.filter(
    (event) => event.stage !== 5 || !inactive.has(event.payload?.registry_type)
  );
}

export function tripSummary(item) {
  const states = currentStates(item?.states || []);
  const problem = [...states]
    .sort((a, b) => a.stage - b.stage)
    .find((event) => tone(event.status) === "problem");
  const latest = [...states].sort(
    (a, b) => b.stage - a.stage || b.position - a.position
  )[0];
  const active = problem || latest;
  const complete =
    latest?.stage === 9 &&
    states
      .filter((event) => event.stage === 9)
      .every((event) => tone(event.status) === "ready") &&
    !problem;
  const kind = problem ? "problem" : complete ? "ready" : "waiting";
  const action =
    {
      tm_error: "Проверить ставку в ТрансМенеджере",
      tms_error: "Уточнить тариф в системе заказчика",
      matrix_error: "Проверить матрицу на дату заявки",
      erp_error: "Проверить тариф в учётной системе",
    }[problem?.status] ||
    (problem
      ? "Проверить причины и дополнить подтверждения"
      : complete
      ? "Получены внешний номер и статус реестра"
      : "Ожидать следующего этапа обработки");
  return {
    kind,
    title: problem
      ? "Требует внимания"
      : complete
      ? "Реестр зарегистрирован"
      : "В обработке",
    stage: active?.stage || 1,
    stageTitle: stages[(active?.stage || 1) - 1],
    reason:
      reasons(active)[0] ||
      (active ? statusText(active.status) : "События ещё не получены"),
    action,
  };
}

export function stageCards(events = []) {
  const states = currentStates(events);
  return stages.map((title, index) => {
    const rows = states.filter((event) => event.stage === index + 1);
    const kind = rows.some((event) => tone(event.status) === "problem")
      ? "problem"
      : !rows.length
      ? "future"
      : rows.some((event) => tone(event.status) === "waiting")
      ? "waiting"
      : "ready";
    return {
      number: index + 1,
      title,
      kind,
      label: {
        problem: "Требует внимания",
        future: "Впереди",
        waiting: "В работе",
        ready: "Пройден",
      }[kind],
    };
  });
}

export function conditionGroups(events = []) {
  const states = currentStates(events);
  const checked = states.filter(
    (event) => event.stage === 5 && event.payload?.registry_type
  );
  if (checked.length)
    return checked.map((event) => ({
      type: event.payload.registry_type,
      conditions: event.payload.conditions || [],
    }));
  return (states.find((event) => event.stage === 4)?.payload?.decisions || [])
    .filter((row) => row.status !== "not_applicable")
    .map((row) => ({
      type: row.registry_type,
      conditions: row.conditions || [],
    }));
}

export function tariffDetails(events = []) {
  const event = currentStates(events).find(
    (row) => row.stage === 3 && row.payload?.prices_without_vat
  );
  return event
    ? {
        prices: event.payload.prices_without_vat,
        mock: event.payload.differences?.matrix_source === "mock_fixture",
        version: event.payload.differences?.matrix_fixture_version,
      }
    : null;
}
